Object.defineProperty(exports, "__esModule", { value: true });
exports.VIZ_QUOTE_LOAD = 'vizurycookiequoteload';
exports.VIZ_QUOTE_REFRESH_AJAX = 'vizuryajax';
exports.VIZ_QUOTE_LOAD_30_SECOND = 'vizurycookie30secquoteload';
exports.VIZ_COOKIE_OPTIONS = {
    maxAge: 86400,
    path: '/',
    domain: '.coverfox.com',
};
